import { SpacingScale } from '@cbhq/cds-common';
import { Banner } from '@cbhq/cds-web/banner/Banner';
import { Box } from '@cbhq/cds-web/layout';

type PaymasterGasBannerProps = {
  spacingTop?: SpacingScale;
  percentageUsed: number;
};
export function PaymasterGasBanner({ spacingTop = 4, percentageUsed }: PaymasterGasBannerProps) {
  const isWarning = percentageUsed < 1;

  return (
    <Box display="block" spacingTop={spacingTop}>
      <Banner
        title="Increase the global limit"
        variant={isWarning ? 'error' : 'warning'}
        startIcon={isWarning ? 'warning' : 'error'}
      >
        {isWarning
          ? `Over 75% of the limit has been utilized. Increase the limit to avoid your service being interrupted.`
          : 'The sponsorship is paused because the limit has been reached.'}
      </Banner>
    </Box>
  );
}
